import NavBar from './components/NavBar';
import WhatsAppWidget from './components/WhatsAppWidget';
import Carousel from './components/Carousel';
import ProjectCards from './components/ProjectCard';
import Valores from './components/Valores';
import Experience from './components/Experience';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div id="inicio">
      <NavBar />
      <Carousel />


      <div className="container my-5">
        <ProjectCards />
      </div>

      <Valores />

      {/* Experience is full-bleed (background spans full viewport) */}
      <Experience />

      <div className="container my-5">
        <Services />
      </div>

      {/* Contact form full-bleed (background spans full viewport) */}
      <ContactForm />

      {/* Footer siempre visible al final */}
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

export default App;
